import { useCallback } from 'react';
import * as authentikOidc from '../auth/authentikOidc';

/**
 * useAppToken, tiny hook returning a stable getToken() function.
 *
 * Replaces the Auth0 pattern of `const { getAccessTokenSilently } = useAuth0()`
 * with `const { getToken } = useAppToken()`. Pure delegation to the
 * Authentik OIDC module, no state, no effects.
 *
 * Usage:
 *   const { getToken } = useAppToken();
 *   const token = await getToken();
 */
export function useAppToken() {
  const getToken = useCallback(() => authentikOidc.getToken(), []);
  return { getToken };
}
